import { useNavigate } from "react-router-dom";
import { useToast } from "../../../components/toast";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { useAuth } from "../../../context/AuthContext";
import { useState } from "react";
import { TeamsAPI } from "../../../APIs/teams.api";
import { AlertTriangle, Trash2 } from "lucide-react";
import { ErrorMessage } from "../../../components/error-message";

export const DeleteTeam = () => {
  const { addToast } = useToast();
  const { handleError, error, clearError } = useErrorHandler();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isConfirming, setIsConfirming] = useState(false);

  const handleDeleteTeam = async () => {
    clearError();
    try {
      const response = await TeamsAPI.deleteTeam();
      if (response.statusCode === 200) {
        addToast({
          message: "El equipo ha sido eliminado",
          type: "success",
          location: "bottom-center",
          duration: 10000,
        });
        logout();
        navigate("/");
      } else {
        handleError(response.message, {
          persist: true,
        });
      }
    } catch (err) {
      handleError("Ocurrió un error al intentar eliminar el equipo.", {
        persist: true,
      });
    }
  };

  return (
    <>
      <div className="p-4 border border-red-200 rounded-md max-w-md w-full mx-auto mt-4 bg-red-50">
        <div className="flex items-center justify-center mb-4">
          <AlertTriangle className="w-6 h-6 text-red-600 mr-2" />
          <h1 className="text-xl md:text-2xl font-bold text-center text-red-700">
            Eliminar equipo
          </h1>
        </div>

        <div className="border-l-4 border-red-600 pl-4 py-2 mb-6">
          <p className="text-sm md:text-base text-gray-800 mb-2">
            Esta acción tendrá las siguientes consecuencias:
          </p>
          <ul className="list-disc pl-5 text-sm md:text-base text-gray-800">
            <li className="mb-1">
              Tu cuenta será{" "}
              <span className="text-red-600 font-bold">desactivada.</span>
            </li>
            <li className="mb-1">
              Las cuentas de{" "}
              <span className="text-red-600 font-bold">todos los miembros</span>{" "}
              del equipo serán desactivadas.
            </li>
          </ul>
        </div>

        {isConfirming ? (
          <div className="mt-6 p-4 bg-red-100 border border-red-300 rounded-lg shadow-sm">
            <div className="flex flex-col items-center">
              <div className="flex items-center mb-4">
                <Trash2 className="w-5 h-5 text-red-600 mr-2" />
                <p className="text-base md:text-lg text-red-700 font-bold">
                  ¿Estás seguro?
                </p>
              </div>
              <p className="text-sm md:text-base text-center text-gray-800 mb-4">
                Esta acción{" "}
                <span className="text-red-600 font-bold">
                  desactivará todas las cuentas
                </span>{" "}
                del equipo.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:justify-center">
                <button
                  onClick={handleDeleteTeam}
                  className="px-4 py-2 bg-red-600 text-white font-bold rounded hover:bg-red-700 transition text-sm md:text-base w-full sm:w-auto focus:ring-2 focus:ring-red-500 focus:ring-offset-2 flex items-center justify-center"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Sí, eliminar el equipo
                </button>
                <button
                  onClick={() => setIsConfirming(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 font-bold rounded hover:bg-gray-50 transition text-sm md:text-base w-full sm:w-auto focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center mt-4">
            <button
              onClick={() => setIsConfirming(true)}
              className="px-6 py-2 bg-red-600 text-white font-bold rounded hover:bg-red-700 transition text-sm md:text-base w-full sm:w-auto focus:ring-2 focus:ring-red-500 focus:ring-offset-2 flex items-center justify-center"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Eliminar equipo
            </button>
          </div>
        )}
      </div>
      {error && (
        <div className=" max-w-md w-full mx-auto mt-4">
          <ErrorMessage message={error} />
        </div>
      )}
    </>
  );
};

export default DeleteTeam;
